import { Login } from '../pages/Auth/Login';
import { TwoFactorChallenge } from '../pages/Auth/TwoFactorChallenge';
import { TwoFactorTutorial } from '../pages/Auth/TwoFactorTutorial';
import { Dashboard } from '../pages/Dashboard/Dashboard';
import { Transactions } from '../pages/Transaction/Transactions';
import { Customers } from '../pages/Customers/Customers';
import { Suppliers } from '../pages/Suppliers/Suppliers';
import Profile from '../pages/Profile/profile';
import { Users } from '../pages/Users/Users';
import { ChangePassword } from '../pages/Auth/ChangePassword';
import { ROLES } from '../utils/permissions';

export const router = [
  {
    path: '/',
    element: <Login />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/two-factor',
    element: <TwoFactorChallenge />,
  },
  {
    path: '/two-factor/tutorial',
    element: <TwoFactorTutorial />,
    public: true,
  },
  {
    path: '/profile',
    element: <Profile />,
  },
  {
    path: '/change-password',
    element: <ChangePassword />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/transactions',
    element: <Transactions />,
  },
  {
    path: '/customers',
    element: <Customers />,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/users',
    element: <Users />,
    roles: [ROLES.ADMIN],
  },
  {
    path: '/suppliers',
    element: <Suppliers />,
    roles: [ROLES.ADMIN],
  },
];
